import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

const MenuConfBasicLoader = () => {
  return (
    <div className="basic-loader basic-loader--min-height">
      <FontAwesomeIcon
        className="font-size-60 color-gray-400"
        icon={faSync}
        spin
      />
    </div>
  );
};

export default MenuConfBasicLoader;
